import defaultsDeep from 'lodash/defaultsDeep';
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeVariables } from './themeVariables';
export function themeVariantProviderFactory() {
    function ThemeVariantProvider(_a) {
        var children = _a.children, values = _a.values, selected = _a.selected;
        return React.createElement(StyledThemeProvider, { theme: values[selected] }, children);
    }
    function buildDefaultThemeProps(values) {
        return values;
    }
    return { ThemeVariantProvider: React.memo(ThemeVariantProvider), buildDefaultThemeProps: buildDefaultThemeProps };
}
export default function ThemeProvider(_a) {
    var children = _a.children, isDark = _a.isDark, values = _a.values;
    var themeValue = React.useMemo(function () {
        var _a;
        var selectedValues = isDark ? values.dark : values.light;
        return defaultsDeep(selectedValues, (_a = values.shared) !== null && _a !== void 0 ? _a : {}, { cssVariables: ThemeVariables });
    }, [isDark, values]);
    return React.createElement(StyledThemeProvider, { theme: themeValue }, children);
}
